export const FALLBACK_IMAGE_ID = 'lh_platzhalter_ohne_abbildung';

/**
 * waits for img loading and then decides if image is visible/exists
 */
async function isImageExists(imgElem: HTMLImageElement, timeout = 5000): Promise<boolean> {
    // wait for image
    await new Promise<void>(res => {
        if (imgElem.complete) {
            return res();
        }
        imgElem.onload = () => res();
        imgElem.onerror = () => res();
        setTimeout(() => res(), timeout); // fallback
    });

    // define if something loaded
    return imgElem.naturalHeight !== 0;
}

/**
 * Check if element contains an img tag (<img>) and checks if the image was loaded fully.
 * If not, remove the entire element.
 */
export async function removeElementIfContainedImageFailedToLoad(element: Element): Promise<void> {
    const imageElement = element.querySelector('img');
    if (!imageElement) {
        return;
    }

    if (!(await isImageExists(imageElement, 1000))) {
        element.remove();
        return;
    }
}

export function getImageUrl(imageId: string, format?: string): string {
    if (format) {
        return `https://i.otto.de/i/otto/${imageId}?${format}`;
    }
    return `https://i.otto.de/i/otto/${imageId}`;
}
